import { createUseStyles } from 'react-jss';

const useStyle = createUseStyles((theme) => ({
  listItem: {
    listStyle: 'none',
    '&:not(:last-child)': {
      borderBottom: `solid 1px ${theme.colors.background.border}`,
    },
    '&.highlighted': {
      backgroundColor: 'rgba(0, 0, 0, 0.02)',
    },
  },
}));

export default useStyle;
